exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.content-wrapper[data-v-4637525c] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 0 5%;\n}\n.loader[data-v-4637525c] {\r\n  position: fixed;\r\n  z-index: 1;\r\n  background: rgb(255, 255, 255);\n}\n.page_title[data-v-4637525c]{\r\n  margin: 0 0 15px 0;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4637525c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/contact/contact.vue
// module id = 604
// module chunks = 0